<template>
  <div class="section-sub-title-wrapper">
    <h3 class="section-sub-title" v-html="text" v-bind="$attrs"></h3>
  </div>
</template>

<script>
export default {
  name: 'SectionTitle',
  props: ['text']
}
</script>
